import React, { Component } from 'react';
import axios from 'axios';
import ScrollupSection from '../components/scrollupSection/scrollUp';
import Header from '../components/welcomeSection/header';
import { Link, withRouter } from 'react-router-dom';
import { v4 as uuidv4, validate } from 'uuid';

class CheckoutTransfer extends Component {
    state = {
        isVerified: false,
        status: '',
        fullName: '',
        email: '',
        city: '',
        address: '',
        province: '',
        purchaseDate: '',
        image: null,
        previewUrl: '',
        total: 0,
        title: '',
        quantity: 0,
        voucher: false,
        uploadError: false,
        clientTransactionId: '',
    }

    async componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const paramClientTransactionId = params.get('trx');
        const isTrusted = validate(params.get('trusted'));

        const { location } = this.props;
        const { client_transaction_id } = location.state || {};

        if (!isTrusted) {
            if (!paramClientTransactionId || !client_transaction_id || paramClientTransactionId !== client_transaction_id) {
                console.error('Parámetros requeridos no encontrados');
                this.goToIndex();
                return;
            }
        }

        try {
            const response = await axios.get('https://api.proyectoshark.com/games/public/purchase/transfer', {
                params: {
                    trx: paramClientTransactionId,
                },
            });

            if (response.status === 200) {
                this.setState({
                    isVerified: response.data.is_verified,
                    status: response.data.status,
                    fullName: response.data.full_name,
                    email: response.data.email,
                    city: response.data.city,
                    address: response.data.address,
                    province: response.data.province,
                    purchaseDate: response.data.purchase_date,
                    total: response.data.total,
                    voucher: response.data.voucher,
                    title: response.data.title,
                    quantity: response.data.quantity,
                    uploadError: false,
                    clientTransactionId: paramClientTransactionId
                });
            } else {
                console.warn('Internal server error', response.status);
                this.goToIndex();
            }
        } catch (error) {
            console.error('Error en la verificación de transferencia:', error);
            this.goToIndex();
        }
    }

    goToIndex = () => {
        this.props.history.push('/')
    }

    handleImageChange = (event) => {
        const file = event.target.files?.[0] || null;

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({
                    image: file,
                    previewUrl: reader.result,
                });
            };
            reader.readAsDataURL(file);
            this.setState({
                ...this.state,
                uploadError: false,
            });
        }
    }

    handleSubmit = () => {
        const { clientTransactionId } = this.state;

        if (this.state.image === null) {
            return
        }

        const formData = new FormData();
        formData.append("images", this.state.image);
        formData.append('clientTransactionId', clientTransactionId);

        axios.put(`https://api.proyectoshark.com/games/public/purchase/transfer`, formData)
            .then((response) => {
                if (response.status === 200) {
                    this.props.history.push({
                        pathname: '/checkout/received',
                        state: {
                            ack: uuidv4(),
                        },
                    })
                } else {
                    console.warn('Error al enviar la imagen', response.status);
                }
            })
            .catch((error) => {
                console.log(error)
                this.setState({
                    ...this.state,
                    uploadError: true,
                });
            });
    }

    formatDate(isoDate) {
        if (!isoDate) return ''
        const date = new Date(isoDate)

        return new Intl.DateTimeFormat('es-EC', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }).format(date)
    }

    render() {
        const { isLoading, image, previewUrl, purchaseDate, total, isVerified, uploadError,
            title, quantity, voucher, fullName, email, address, city, province } = this.state;

        return (
            <div className="miami">
                <ScrollupSection />
                <div className="all-area">
                    <Header />
                    <section className="section about-app-area ptb_50">
                        <div className="container">

                            {isLoading ? (
                                <div className="row justify-content-center">
                                    <div className="col-md-6">
                                        <div className="text-center">
                                            <h2>Cargando...</h2>
                                            <p>Estamos verificando tu compra</p>
                                        </div>                                </div>
                                </div>) : (
                                <>
                                    <div className="text-center">
                                        <h4>¡Gracias! Tu pedido ha sido recibido.</h4>
                                        <p>Finaliza tu compra con los siguientes pasos.</p>
                                    </div>

                                    <div className="row justify-content-center mt-4 game-card">
                                        <div className="col-8">
                                            <h3>Detalles del Pedido</h3>
                                            <ul>
                                                <p><strong>Fecha:</strong> {this.formatDate(purchaseDate)}</p>
                                                <p><strong>Pedido:</strong> {title} x {quantity}</p>
                                                <p><strong>Total:</strong> ${total}</p>
                                                <p><strong>Método de pago:</strong> Transferencia bancaria o depósito</p>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="row justify-content-center mt-4 game-card">
                                        <div className="col-8">
                                            <h3>Detalles de la compra</h3>
                                            <ul>
                                                <p><strong>Nombre:</strong> {fullName}</p>
                                                <p><strong>Correo:</strong> {email}</p>
                                                <p><strong>Dirección:</strong> {address}</p>
                                                <p><strong>Ciudad:</strong> {city}</p>
                                                <p><strong>Provincia:</strong> {province}</p>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="row justify-content-center game-card">
                                        <div className="col-8">
                                            <h3>Instrucciones de Pago</h3>
                                            <p>
                                                <strong>1</strong>. Transfiere o deposita EL MONTO TOTAL de la compra, tienes un tiempo máximo de 1 hora para adjuntar el comprobante, los datos bancarios se encuentran mas adelante.
                                            </p>
                                            <br />
                                            <p>
                                                <strong>2</strong>. Adjunta tu comprobante en la opción que se encuentra al final.
                                            </p>
                                            <br />
                                            <p>
                                                <strong>3</strong>. Recibirás tus números por correo electrónico una vez verificado el pago. (Recuerda, esto puede tardar en caso de transferencias interbancarias).
                                            </p>
                                            <br />
                                            <p>
                                                <strong>¡IMPORTANTE!, No cierres esta pagina si ya realizaste el pago y aun no cargas el comprobante</strong>.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row justify-content-center game-card">
                                        <div className="col-8">
                                            <h3>Datos Bancarios</h3>
                                            <div className="row">
                                                <div className="col-12 col-md-4 d-flex justify-content-center align-items-center">
                                                    <img src="https://shark-images.nyc3.digitaloceanspaces.com/logo_guayaquil.png" alt="Banco de Guayaquil" style={{ width: '200px', margin: '10px' }} />
                                                </div>
                                                <div className="col-12 col-md-8 p-3">
                                                    <p><strong>Cuenta Corriente:</strong> 31432383</p>
                                                    <p><strong>Nombre:</strong> Proyecto Sharks S.A.</p>
                                                    <p><strong>Cédula:</strong> 0791844358001</p>
                                                    <p><strong>Correo:</strong> proyectosharkproshark@gmail.com</p>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="row">
                                                <div className="col-12 col-md-4 d-flex justify-content-center align-items-center">
                                                    <img src="https://shark-images.nyc3.digitaloceanspaces.com/logo_pichincha.png" alt="Banco de Guayaquil" style={{ width: '300px', margin: '10px' }} />
                                                </div>
                                                <div className="col-12 col-md-8 p-3">
                                                    <p><strong>Cuenta de Ahorros:</strong> 2100332648</p>
                                                    <p><strong>Nombre:</strong> Proyecto Sharks S.A.</p>
                                                    <p><strong>Cédula:</strong> 0791844358001</p>
                                                    <p><strong>Correo:</strong> proyectosharkproshark@gmail.com</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row justify-content-center game-card">
                                        <div className="col-8">
                                            <h3>Tus Números</h3>
                                            <p>Serán generados una vez que verifiquemos el pago. Recuerda, esto puede tardar ya que la verificación de pago es manual. Por favor, sigue las instrucciones detalladas más arriba en esta misma página.</p>
                                        </div>
                                    </div>

                                    {(!isVerified || !voucher) && (<div className="game-card">
                                        <div className='div-transfer-image'>
                                            <div className="row justify-content-center">
                                                <div className="col-10">
                                                    <div className="text-center p-3">
                                                        <h3>Adjunta tu comprobante aqui</h3>
                                                        <p>No cierres esta pagina si ya realizaste el pago y aun no cargas el comprobante</p>
                                                    </div>
                                                    <div className="container p-3">
                                                        <div className="mb-3">
                                                            <input
                                                                type="file"
                                                                className="form-control"
                                                                id="imageInput"
                                                                accept="image/*"
                                                                onChange={this.handleImageChange}
                                                            />
                                                        </div>

                                                        {uploadError && <small className="error">Hubo un error al intentar cargar tu comprobante, verifica que sea el correcto</small>}

                                                        {previewUrl && (
                                                            <div className="text-center mb-3">
                                                                <img
                                                                    src={previewUrl}
                                                                    alt="Vista previa"
                                                                    className="img-thumbnail"
                                                                    style={{ maxHeight: '200px' }}
                                                                />
                                                            </div>
                                                        )}

                                                        {image && (
                                                            <div className="text-end">
                                                                <button className="buy-btn mt-3" onClick={this.handleSubmit}>
                                                                    Enviar
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>)}
                                </>
                            )}

                            {isVerified && (<div className="row justify-content-center">
                                <div className="col-md-6 text-center">
                                    <h2>¡Compra verificada!</h2>
                                    <p>Revisa tu correo electrónico.</p>
                                    <Link to="/">
                                        <button className="buy-btn mt-3">Volver al inicio</button>
                                    </Link>
                                </div>
                            </div>)}

                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

export default withRouter(CheckoutTransfer);
